import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { contactSecure } from "../../../../domain/contact/contactActions";
import ContactForm from "../../../forms/secure/ContactForm";
import StatusMessage from "../../../presentational/StatusMessage";
import * as StatusMessages from "../../../../constants/StatusMessages";
import { FormattedMessage } from "react-intl";
import PhoneLink from "../../../presentational/PhoneLink";
import { resetMessages } from "../../../../domain/misc/miscActions";
import WithAccounts, { AccountLoadStatus } from "../WithAccounts/WithAccounts";
import ContactHoursOfOperation from "../../../presentational/ContactHoursOfOperation/ContactHoursOfOperation";
import track from "react-tracking";
import MDPatientSheet from "assets/scripts/components/common/MDPatientSheet/MDPatientSheet";
class ContactSecure extends Component {
    componentDidMount() {
        this.props.resetMessages("contact");
    }
    render() {
        return (<WithAccounts>
				{accounts => {
            const routeGroups = [...accounts.accts.deceased, ...accounts.accts.live];
            const infoSheets = [];
            const groupInfoMap = new Map();
            routeGroups.filter(it => it.primary.hasMDPatientInfoSheet)
                .forEach(g => groupInfoMap.set(g.primary.clientId, g.primary.clientName));
            for (const [key, value] of groupInfoMap) {
                infoSheets.push(<div key={key}>
								<MDPatientSheet clientId={key} clientName={value} hasSpanish={routeGroups.find(it => it.primary.clientId === key).primary.hasMDPatientInfoSheetES}/>
							</div>);
            }
            ;
            return (<div className="wrapper wrapper_narrow">
							<div className="vr vr_x4">
								<h1 className="hdg js-pageHeader">
									<FormattedMessage id="contactSecure.header" defaultMessage="Contact Us"/>
								</h1>
							</div>

							<AccountLoadStatus {...accounts}/>

							{!accounts.loading && accounts.error == null && (<Fragment>
									<StatusMessage isError={!this.props.contactIsSuccess} isSuccess={this.props.contactIsSuccess} isActive={this.props.contactIsSuccess !== null ? true : false} customMessage={this.props.contactIsSuccess ?
                StatusMessages.CONTACT.SUCCESS_MESSAGE_CONTACT :
                ""} domain="contact" autoReset={false}/>
									<StatusMessage isError isActive={this.props.contactError ? true : false} error={this.props.contactError ? this.props.contactError : null} customMessage={StatusMessages.CONTACT.INTRO_CONTACT} domain="contact" autoReset={false}/>
									<div className="vr vr_x5">
										<div className="text">
											<p>
												<FormattedMessage id="contact.secure.message" defaultMessage="To contact us, please fill out the form below, or give us a call at {phone}." values={{
                phone: <PhoneLink />
            }}/>
											</p>
											<div style={{ paddingTop: "10px" }}>
												<span style={{ paddingBottom: "8px", fontWeight: 600, display: "block" }}>
													<FormattedMessage tagName="h2" id="notice.languageServices.title" defaultMessage="For New York City Residents"/>
												</span>

												<FormattedMessage id="notice.languageServices" defaultMessage={"DCM Services does not offer language access services.  However, we do offer translation of verbal and written communications into Spanish but on a limited basis. Translation and description of common debt collection terms is available in multiple languages on the Department of Consumer Affairs website, {link}."} values={{
                link: <a className="link" href="http://www.nyc.gov/dca">www.nyc.gov/dca</a>
            }}/>
											</div>
										</div>
									</div>

									<ContactHoursOfOperation />

									<div className="vr vr_x5">
										<ContactForm customFields={routeGroups} fieldErrors={this.props.contactFieldErrors} sendToAPI={this.props.contactSecure} isLoading={this.props.contactIsLoading}/>
									</div>
									<StatusMessage isLoad isActive={this.props.contactIsLoading}/>
									{infoSheets}
								</Fragment>)}
						</div>);
        }}
			</WithAccounts>);
    }
}
/* --- React Redux bootstrapping --- */
const mapStateToProps = (state) => ({
    contactError: state.contact.error,
    contactFieldErrors: state.contact.fieldErrors,
    contactIsLoading: state.contact.isLoading,
    contactIsSuccess: state.contact.isSuccess,
});
const bindActionsToProps = {
    contactSecure,
    resetMessages
};
/* Create and export container component that wraps ContactSecure for property binding */
export default track({ page: "ContactSecure" }, { dispatchOnMount: true })(connect(mapStateToProps, bindActionsToProps)(ContactSecure));



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/secure/ContactSecure/ContactSecure.tsx